/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AppRoute } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AppRouteServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get App Routes
     * Returns the Angular route configuration from the database. Called during app initialization before login.
     */
    getAppRoutes(extraHttpRequestParams?: any): Observable<Array<AppRoute>>;

}
